<template>
  <div :class="[ns.e('item'), ns.e(variant)]">
    <picture-filled v-if="variant === 'image'" />
  </div>
</template>

<script lang="ts" setup>
import { useNamespace } from '@jdesign-vue/hooks'
import { ImageF as PictureFilled } from '@jd/jdesign-icons-vue'
import { skeletonItemProps } from './skeleton-item'

defineOptions({
  name: 'JdSkeletonItem',
})
defineProps(skeletonItemProps)
const ns = useNamespace('skeleton')
</script>
